var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Text from "../text/Text";
import React from "react";
import UrlUtil from "../utils/UrlUtil";
var RecommendationItemProductName = function (_a) {
    var item = _a.item, onClick = _a.onClick, rest = __rest(_a, ["item", "onClick"]);
    var product_name = item.product_name;
    var url = UrlUtil.getProductUrl(item);
    return (React.createElement(Text, __assign({ as: "a", href: url, fontWeight: "bold", fontSize: [2, 2, 3], letterSpacing: "-0.03em", mb: 1, onClick: onClick }, rest), product_name));
};
export default RecommendationItemProductName;
//# sourceMappingURL=RecommendationItemProductName.js.map